/**
 * 🔒 Privacidad en el navegador:
 *  - Modo privado (botón 👁 / Alt+P): difumina importes (€, CHF) y cifras grandes; se recuerda.
 *  - Bloqueo automático: cierra sesión tras 30 min sin actividad (o al volver a la pestaña tras 30 min).
 */
const IDLE_MS = 30 * 60 * 1000;
const MONEY = /(\d[\d.,\s]*\s?(€|eur|chf)|€\s?\d|chf\s?\d)/i;

const CSS = `
html.priv .pv{filter:blur(7px);transition:filter .2s}
html.priv .pv:hover{filter:blur(0)}
.pv-btn{width:32px;height:32px;border-radius:10px;display:grid;place-items:center;color:#7D8AA6;font-size:15px;border:1px solid transparent}
.pv-btn:hover{background:rgba(255,255,255,.05);color:#EEF3FB}
html.priv .pv-btn{color:#5AAEFF;border-color:rgba(90,174,255,.35);background:rgba(90,174,255,.08)}
.lock-ov{position:fixed;inset:0;z-index:100;display:grid;place-items:center;background:rgba(5,9,20,.82);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);color:#EEF3FB;text-align:center}
.lock-ov b{display:block;font-size:20px;margin:10px 0 6px}
`;

function markMoney(root) {
  if (!document.documentElement.classList.contains('priv')) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n; while ((n = walker.nextNode())) {
    const t = n.nodeValue; if (!t || t.length > 80 || !MONEY.test(t)) continue;
    const el = n.parentElement; if (el && !el.closest('input,textarea,.qa-ov,.esq-sheet')) el.classList.add('pv');
  }
  root.querySelectorAll && root.querySelectorAll('.text-3xl,.text-4xl').forEach((e) => { if (/\d{3,}/.test(e.textContent || '')) e.classList.add('pv'); });
}

export function mountPrivacy({ logout } = {}) {
  if (window.__privMounted) return; window.__privMounted = true;
  const st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  const root = document.documentElement;
  const set = (on) => { root.classList.toggle('priv', on); localStorage.setItem('priv_mode', on ? '1' : '0'); if (on) markMoney(document.body); };
  set(localStorage.getItem('priv_mode') === '1');
  const obs = new MutationObserver((ms) => { if (!root.classList.contains('priv')) return; for (const m of ms) m.addedNodes.forEach((x) => { if (x.nodeType === 1) markMoney(x); else if (x.nodeType === 3 && x.parentElement) markMoney(x.parentElement); }); });
  obs.observe(document.body, { childList: true, subtree: true, characterData: true });

  function addButton() {
    const right = document.querySelector('.tb-right'); if (!right || right.querySelector('.pv-btn')) return;
    const b = document.createElement('button'); b.className = 'pv-btn'; b.title = 'Modo privado: ocultar importes (Alt+P)'; b.textContent = '👁';
    b.onclick = () => set(!root.classList.contains('priv'));
    right.insertBefore(b, right.firstChild);
  }
  addButton(); new MutationObserver(addButton).observe(document.getElementById('app') || document.body, { childList: true, subtree: false });
  setInterval(addButton, 3000);
  document.addEventListener('keydown', (e) => { if (e.altKey && (e.key === 'p' || e.key === 'π')) { e.preventDefault(); set(!root.classList.contains('priv')); } });

  // ---- bloqueo por inactividad ----
  let last = Date.now();
  const bump = () => { last = Date.now(); };
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((ev) => window.addEventListener(ev, bump, { passive: true }));
  const check = async () => {
    if (Date.now() - last < IDLE_MS) return;
    last = Date.now() + 1e12; // evitar dobles
    const ov = document.createElement('div'); ov.className = 'lock-ov'; ov.innerHTML = '<div><div style="font-size:42px">🔒</div><b>Sesión bloqueada por inactividad</b><div style="color:#7D8AA6;font-size:13px">Vuelve a entrar para continuar</div></div>';
    document.body.appendChild(ov);
    try { logout && (await logout()); } catch {}
    setTimeout(() => location.reload(), 1200);
  };
  setInterval(check, 30 * 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
}
